<template>
    <div class="aides">
        <div class="my-aides">
            <div class="aides-item">
                <span><i class="adies-icon"></i></span>
                <span>添加</span>
                <span>小助手</span>
            </div>
            <div class="code-aides-item">
                <span>请用微信扫码添加小助手</span>
                <div>
                <img :src="aidesCode" alt="" v-if="aidesCode">
                </div>
            </div>
            <div class="line-item">
            </div>
            <div class="group-item">
                <span><i class="group-icon"></i></span>
                <span>加入</span>
                <span>交流群</span>
            </div>
            <div class="code-group-item">
                <span>请用微信扫码加入交流群</span>
                <div>
                <img :src="qunCode" alt="" v-if="qunCode">
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Aides',
    props: ['aidesCode', 'qunCode'],
    components: {
        showAides: false,
        showGroup: false
    },
    computed: {

    }
};
</script>

<style scoped>
.my-aides {
    width: 60px;
    height: 182px;
    box-shadow: 0px 4px 12.4px 0px rgba(0, 0, 0, 0.06);
    background-color: rgba(255, 255, 255, 1);
    border-radius: 10px 0 0 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
}

.line-item {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 40px;
    height: 1px;
    background-color: rgba(229, 229, 229, 1);
}

.aides-item,
.group-item {
    width: 100%;
    height: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    cursor: pointer;
}

.adies-icon {
    display: inline-block;
    width: 25px;
    height: 25px;
    background: url(../../../assets/images/kefu.png) no-repeat center center;
    background-size: 100% 100%;
}

.group-icon {
    display: inline-block;
    width: 25px;
    height: 25px;
    background: url(../../../assets/images/qun.png) no-repeat center center;
    background-size: 100% 100%;
}

.code-aides-item {
    width: 172px;
    height: 180px;
    border-radius: 10px;
    position: absolute;
    left: -180px;
    top: 2px;
    box-shadow: 0px 4px 12.4px 0px rgba(0, 0, 0, 0.06);
    background-color: rgba(255, 255, 255, 1);
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    display: none;
    span {
        display: inline-block;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 12px;
        line-height: 100%;
        text-align: center;
    }
    img {
        display: inline-block;
        margin-top: 19px;
        width: 100px;
        height: 100px;
    }
}
.code-group-item {
    width: 172px;
    height: 180px;
    border-radius: 10px;
    position: absolute;
    left: -180px;
    top: 2px;
    box-shadow: 0px 4px 12.4px 0px rgba(0, 0, 0, 0.06);
    background-color: rgba(255, 255, 255, 1);
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    display: none;
    span {
        display: inline-block;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 12px;
        line-height: 100%;
        text-align: center;
    }
    img {
        display: inline-block;
        margin-top: 19px;
        width: 100px;
        height: 100px;
    }
}
.aides-item:hover {
    span {
        color: #0D70ED;
    }
    .adies-icon {
        background: url(../../../assets/images/kefuhover.png) no-repeat center center;
        background-size: 100% 100%;
    }
}
.aides-item:hover + .code-aides-item {
    display: flex;
}
.group-item:hover {
    span {
        color: #0D70ED;
    }
    .group-icon {
        background: url(../../../assets/images/qunhover.png) no-repeat center center;
        background-size: 100% 100%;
    }
}
.group-item:hover + .code-group-item {
    display: flex;
}
</style>